import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CartStep2ProductRepository } from '@/core/domain/cart-step2/repositories/cart-step2-product.repository';
import { sendCartStep2ProductUseCase } from '@/core/domain/cart-step2/usecases/sendCartStep2Product.usecase';
import { CartStep2ProductImplRepository } from './cart-step2-product-impl.repository';

const sendCartStep2ProductUseCaseFactory = (
    cartStep2ProductRepository: CartStep2ProductRepository,
) => new sendCartStep2ProductUseCase(cartStep2ProductRepository);

@NgModule({
    imports: [CommonModule],
    providers: [
        {
            provide: sendCartStep2ProductUseCase,
            useFactory: sendCartStep2ProductUseCaseFactory,
            deps: [CartStep2ProductRepository],
        },
        {
            provide: CartStep2ProductRepository,
            useClass: CartStep2ProductImplRepository,
        },
    ],
})
export class CartStep2ProductDataModule {}
